import React, { useCallback } from "react";
import { Grid } from "@material-ui/core";
import { ReportJobAction } from "actions/reportJob";
import {
  getEndDateValidation,
  getStartDateValidation,
} from "components/MultiSaleReports/commonValidation";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { ModalActions } from "components/MultiSaleReports/ManyReportsForm/BulkReportFormCommon";
import { Reports } from "constants/reports";
import {
  DetailedFinancialStatementFormValues,
  DetailedFinancialStatementForm,
} from "./Form";

type SupportedReportType = "DetailedFinancialStatementReport";

interface CreateFinancialStatementReportJobsFormProps {
  reportSlug: SupportedReportType;
  onClose: () => void;
}

type DetailedFormValueType = {
  report: SupportedReportType;
} & DetailedFinancialStatementFormValues;

export const getValidationSchema = (dateRequired = true) =>
  Yup.object().shape({
    startDate: getStartDateValidation("endDate", {
      isYearOptionAllowed: true,
      dateRequired,
    }),
    endDate: getEndDateValidation(dateRequired),
    showStockDetails: Yup.boolean().nullable(),
  });

export function CreateDetailedFinancialStatementReportJobsForm(
  props: CreateFinancialStatementReportJobsFormProps,
): React.JSX.Element {
  const { reportSlug, onClose } = props;

  const dispatch = useDispatch();

  const onSubmit = useCallback(
    (values: DetailedFormValueType) => {
      dispatch(ReportJobAction.createBulk(values));
      onClose();
    },
    [dispatch, onClose],
  );

  const initialValues: DetailedFormValueType = {
    report: reportSlug,
    startDate: null,
    endDate: null,
    showStockDetails: false,
  };

  const isOutstandingStatementReport =
    reportSlug === Reports.OutstandingStatementReport.slug;

  const dateRequired = !isOutstandingStatementReport;

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={getValidationSchema(dateRequired)}
      onSubmit={onSubmit}
    >
      <Form>
        <Grid container spacing={2}>
          <DetailedFinancialStatementForm />
        </Grid>
        <ModalActions
          onClose={onClose}
          allowInitialSubmit={isOutstandingStatementReport}
        />
      </Form>
    </Formik>
  );
}
